import React, {useCallback, useEffect, useState} from 'react';
import {pickUserResponse} from '../../hooks/Auth';
import Loading from '../style-guide/loading/Loading';
import {apiHooks} from '../../hooks/useFetch';
import {Api, AppRouters, AppSettings} from '../../settings';
import {StorageService} from '../../service/storage';
import {expirationTimeout, isValidExpirationToken, toastHelper} from '../../shared';
import {authPatchStateAction, invalidateUserAction, logoutAction} from '../../store/_auth/auth.actions';
import {checkNewReportStatus} from "../../pages/new-report/store/new-report.actions";

import {connect} from 'react-redux';

const PrivateRoute = (props) => {
    const {
        layout: Layout,
        component: Component,
        guestUser = true,
        expirationToken,
        isAuthenticated,
        userInfo,
        actions,
        ...others
    } = props;

    const {execute: userVerifierEndpoint} = apiHooks.useGet(Api.userInfo, true, {});
    const [isLoading, setLoading] = useState(true);
    const ticket = StorageService.getItem(AppSettings.ticketName);

    const invalidateTicket = useCallback(async () => {
        if (!guestUser) {
            actions.onSignOut(AppRouters.signIn);
            toastHelper.info('Debe autenticarse para acceder a rutas seguras.');
            return;
        }

        actions.invalidateUser();
    }, [guestUser, actions]);

    useEffect(() => {
        async function check() {
            // if user was recently authenticated, skip validation request until temporal token expires
            if (ticket && isValidExpirationToken(expirationToken)) {
                return setLoading(false);
            }

            // if user was previously authenticated, but temporal token is expired
            // verify the user authentication and save on cache
            if (ticket) {
                setLoading(true);
                try {
                    const response = await userVerifierEndpoint();

                    if (response.status < 400) {
                        const user = pickUserResponse(response);
                        actions.updateAuthState({
                            isAuthenticated: true,
                            user,
                            expirationToken: expirationTimeout()
                        });

                        return setLoading(false);
                    }
                } catch (e) {

                }
            }

            if (guestUser) {
                actions.invalidateUser();
                // if this route allows access for unauthenticated user
                // set loading to false and allow render of children view
                // @NOTE: make sure children view don't required user data
                return setLoading(false);
            }

            // if the user is not authenticated and this route don't allow guest users
            // redirect to login route and alert the user with the reason of the redirection
            await invalidateTicket();
        }

        check();
    }, []);

    const pageProps = {
        isAuthenticated,
        userInfo,
        ...actions,
        ...others
    };

    return isLoading ? <Loading/> : (
        <Layout
            {...pageProps}
            checkNewReportStatus={actions.checkNewReportStatus}>
            <Component {...pageProps}/>
        </Layout>
    );
};

const mapStateToProps = (state) => ({
    expirationToken: state.authReducers.expirationToken,
    isAuthenticated: state.authReducers.isAuthenticated,
    userInfo: state.authReducers.user,
});

const mapDispatchToProps = dispatch => {
    return {
        actions: {
            updateAuthState: (payload) => dispatch(authPatchStateAction(payload)),
            onSignOut: (navigateTo) => dispatch(logoutAction(navigateTo)),
            invalidateUser: () => dispatch(invalidateUserAction()),
            checkNewReportStatus: (navigateTo) => dispatch(checkNewReportStatus({navigateTo}))
        },
        dispatch
    }
};

export default React.memo(connect(
    mapStateToProps,
    mapDispatchToProps
)(PrivateRoute));
